class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    //MVスライダー
    const mvSwiper = new Swiper(".swiper-mv", {
      loop: true,
      effect: 'fade',
      speed: 1000,
      autoplay: { // 自動再生
        delay: 3500, // 1.5秒後に次のスライド
      },
      slidesPerView: "auto"
    });


    if (window.matchMedia('(min-width: 768px)').matches) {
      const html = document.querySelector("html")
      // let lenis = new Lenis();
      // function raf(time) {
      //   lenis.raf(time);
      //   requestAnimationFrame(raf);
      // }

      // requestAnimationFrame(raf);

      // 診療科目　固定アニメーション
      const scrollItems = document.querySelectorAll(".js-scroll-item")
      let percentage


      gsap.to('.js-scroll-item',
      {
        scrollTrigger: {
          trigger: '.js-scrollWrap',
          pin: true, // trigger要素を固定
          // markers:true,
          scrub: 0.8,
          ease:'none',
          start: '-=180',
          end:'+=5100',
          duration: 0.5,
          // onEnter: () => {
          //   let lenis = new Lenis();
          //   function raf(time) {
          //     lenis.raf(time);
          //     requestAnimationFrame(raf);
          //   }

          //   requestAnimationFrame(raf);
          // },

          onUpdate:(self)=>{

            percentage = self.progress.toLocaleString( undefined, { maximumFractionDigits:3 })*100;

            scrollItems.forEach((ele,i) => {
              if( i * 20  <= percentage &&  percentage <= (i + 1) * 20){
                let scrollNum
                scrollNum = percentage / 20
                scrollNum = scrollNum - ((scrollNum > 0) ? Math.floor(scrollNum) : Math.ceil(scrollNum));

                if(scrollNum !== 0){

                  const dataNum = ele.dataset.num
                  if(dataNum == (i + 1)){
                    const nextEle = ele.nextElementSibling
                    const EleTxt = ele.querySelector(".js-scroll-txt")

                    const img = document.querySelector(`.js-change-img-0${i + 2}`)

                    // console.log(Math.round(100 - scrollNum / 10) * 10);

                    if(nextEle){
                      const nextEleTxt = nextEle.querySelector(".js-scroll-txt");
                      const nextEleLine = nextEle.querySelector(".js-scroll-line");
                      const eleLine = ele.querySelector(".js-scroll-line")
                      nextEle.style.opacity = scrollNum + 0.5
                      nextEleTxt.style.opacity = scrollNum
                      nextEleTxt.style.height = `${scrollNum * 20}rem`
                      ele.style.opacity = 1.5 - scrollNum
                      EleTxt.style.opacity = 1 - scrollNum
                      EleTxt.style.height = `${ 20 - scrollNum * 20}rem`

                      // テキスト部分
                      if(Math.round(100 - scrollNum * 100) < 25){

                        nextEleLine.style.width = "100%"
                        eleLine.style.width = 0
                        EleTxt.style.height = 0
                        EleTxt.style.opacity = 0
                        img.style.transform = `translate(0,0)`

                      }else if(75 < Math.round(100 - scrollNum * 100)){
                        eleLine.style.width = "100%"
                        nextEleLine.style.width = 0
                        nextEleTxt.style.opacity = 0
                        nextEleTxt.style.height = 0
                        img.style.transform = `translate(0,100%)`

                      }
                      else{
                        eleLine.style.width = `${100 - scrollNum * 100}%`
                        nextEleLine.style.width = `${scrollNum * 100}%`
                        img.style.transform = `translate(0,${Math.round(100 - scrollNum * 100)}%)`
                      }


                    }else{
                      ele.style.opacity = 1
                      EleTxt.style.opacity = 1
                      EleTxt.style.height = "16rem"
                    }
                  }
                }
              }
            });
            },
        },

      });

    }

    if (window.matchMedia('(max-width: 767px)').matches) {
      const reserveBtn = document.querySelector(".p-top__reserve")
      const reserveLine = document.querySelector(".js-reserve-line").getBoundingClientRect().top

      window.addEventListener("scroll", () => {
        var scroll_y = window.scrollY;
        if(reserveLine < scroll_y){
          reserveBtn.classList.add("is-hidden")
        }else{
          reserveBtn.classList.remove("is-hidden")
        }
      })

    }
    const breakpoint = window.matchMedia("(max-width:767px)");

    breakpoint.addEventListener("change", () => {
      window.location.reload();
    });

  }
}